import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { getCrmCategoriesRevenue, getCrmCategoriesQuantity } from "../../api";
import { useAnalyticsFetch } from "./hooks/useAnalyticsFetch";
import BarChartCard from "./components/BarChartCard";

const Categories = ({ filter, startDate, endDate }) => {
  const [metric, setMetric] = useState("revenue");

  const apiFn = metric === "revenue" ? getCrmCategoriesRevenue : getCrmCategoriesQuantity;
  const { data, loading } = useAnalyticsFetch(apiFn, [filter, startDate, endDate, 20]);

  return (
    <Container sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}>
      <Box sx={{ marginBottom: "1rem" }}>
        <ToggleButtonGroup
          size="small"
          value={metric}
          exclusive
          onChange={(event, newMetric) => {
            if (newMetric) {
              setMetric(newMetric);
            }
          }}
        >
          <ToggleButton value="revenue">Revenue</ToggleButton>
          <ToggleButton value="quantity">Quantity</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <BarChartCard
        title={metric === "revenue" ? "Category Revenue" : "Category Quantity Sold"}
        labels={data?.chart?.labels || []}
        series={data?.chart?.series || []}
        label={metric === "revenue" ? "Revenue" : "Quantity"}
        loading={loading}
        currency={metric === "revenue"}
      />
    </Container>
  );
};

Categories.propTypes = {
  filter: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default Categories;
